import { Injectable, inject } from '@angular/core';
import { SessionActions, SessionSelectors } from '@next/core-lib/session';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { mergeMap, withLatestFrom } from 'rxjs/operators';

import { cropYearChanged, setCropYear } from './actions';
import { normalizeCropYear } from './selectors';

@Injectable()
export class CropYearEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  setCropYear$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCropYear),
      withLatestFrom(this.store.select(SessionSelectors.selectSessionState)),
      mergeMap(([{ cropYear }, session]) => {
        const normalizedCropYear = normalizeCropYear(cropYear);
        const currentSession = session ?? {};
        const arable =
          currentSession.arable && typeof currentSession.arable === 'object' && !Array.isArray(currentSession.arable)
            ? currentSession.arable
            : {};

        return [
          SessionActions.setSession({
            data: {
              ...currentSession,
              arable: {
                ...arable,
                cropYear: normalizedCropYear,
              },
            },
          }),
          cropYearChanged({ cropYear: normalizedCropYear }),
        ];
      }),
    ),
  );
}
